/**
 * Context to provide locale information from server-side (x-locale header) to client components
 * This ensures components can access the actual locale from the x-locale header instead of router.locale
 */

import React, { createContext, useContext, ReactNode } from 'react';

interface LocaleContextValue {
  serverLocale?: string;
}

const LocaleContext = createContext<LocaleContextValue>({});

interface LocaleProviderProps {
  children: ReactNode;
  serverLocale?: string;
}

export const LocaleProvider: React.FC<LocaleProviderProps> = ({ children, serverLocale }) => {
  return <LocaleContext.Provider value={{ serverLocale }}>{children}</LocaleContext.Provider>;
};

export const useLocaleContext = () => {
  return useContext(LocaleContext);
};
